export enum LangEnum {
    ES = "es",
    EN = "en",
}